/*
 * @Description: 日期格式转换
 * @Autor: xiaona.wang
 * @Date: 2021-11-09 13:57:59
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-11-10 16:43:42
 */

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length));
  }
  const o = {

    /*
     * "M+": date.getMonth() + 1,
     * "d+": date.getDate(),
     * "h+": date.getHours(),
     * "m+": date.getMinutes(),
     * "s+": date.getSeconds()
     */

    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "H+": date.getHours(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3),
    "S": date.getMilliseconds()
  };
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : (`00${o[k]}`).substr((`${o[k]}`).length));
    };
  }
  return fmt;
};
